import React from 'react';
import { useFontSize, FontSizeOption } from '../../contexts/FontSizeContext';

const FontSizeControl: React.FC = () => {
  const { fontSize, setFontSize } = useFontSize();

  const handleFontSizeChange = (size: FontSizeOption) => {
    setFontSize(size);
  };

  return (
    <div className="flex items-center gap-1 bg-gray-100 dark:bg-gray-800 rounded-md p-1">
      <button
        onClick={() => handleFontSizeChange('small')}
        className={`flex items-center justify-center w-8 h-8 rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-surface-light dark:focus:ring-offset-background-card ${
          fontSize === 'small'
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-text-primary shadow-sm'
            : 'text-gray-600 dark:text-text-secondary hover:text-gray-900 dark:hover:text-text-primary'
        }`}
        aria-label="Small font size"
        title="Small font size"
      >
        <span className="text-xs font-bold">A</span>
      </button>
      
      <button
        onClick={() => handleFontSizeChange('medium')}
        className={`flex items-center justify-center w-8 h-8 rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-surface-light dark:focus:ring-offset-background-card ${
          fontSize === 'medium'
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-text-primary shadow-sm'
            : 'text-gray-600 dark:text-text-secondary hover:text-gray-900 dark:hover:text-text-primary'
        }`}
        aria-label="Medium font size"
        title="Medium font size"
      >
        <span className="text-sm font-bold">A</span>
      </button>
      
      <button
        onClick={() => handleFontSizeChange('large')}
        className={`flex items-center justify-center w-8 h-8 rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-surface-light dark:focus:ring-offset-background-card ${
          fontSize === 'large'
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-text-primary shadow-sm'
            : 'text-gray-600 dark:text-text-secondary hover:text-gray-900 dark:hover:text-text-primary'
        }`}
        aria-label="Large font size"
        title="Large font size"
      >
        <span className="text-base font-bold">A</span>
      </button>
    </div>
  );
};

export default FontSizeControl;

